/**
 * Track List Component (Left column)
 */

import React from "react";
import { useSessionStore } from "../store/sessionStore";
import TrackHeader from "./TrackHeader";
import "./TrackList.css";

const TrackList: React.FC = () => {
  const { tracks, drafts } = useSessionStore();

  return (
    <div className="track-list">
      {/* Base track always first */}
      {tracks
        .filter((t) => t.kind === "base")
        .map((track) => (
          <TrackHeader key={track.id} track={track} isDraft={false} />
        ))}

      {/* Published tracks */}
      {tracks
        .filter((t) => t.kind === "recording")
        .map((track) => (
          <TrackHeader key={track.id} track={track} isDraft={false} />
        ))}

      {/* Draft tracks (local only) */}
      {drafts.map((draft) => (
        <TrackHeader key={draft.localId} draft={draft} isDraft={true} />
      ))}
    </div>
  );
};

export default TrackList;
